var _linearGradient, _path, _path2, _path3, _path4, _path5, _path6, _linearGradient2, _path7, _linearGradient3, _path8, _linearGradient4, _path9, _linearGradient5, _path10, _linearGradient6, _path11, _linearGradient7, _path12, _path13, _path14, _linearGradient8, _path15, _path16, _path17, _linearGradient9, _path18, _path19, _path20, _linearGradient10, _path21, _path22;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThrift(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2392.5 4226.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "thrift",
    x1: -5167.1,
    x2: -4570.1,
    y1: 697.6,
    y2: 1395.6,
    gradientTransform: "rotate(-65 -2053 -4777.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f69923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#f79a23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#e97826"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#thrift)",
    d: "M1798.9 20.1C1732.6 59.2 1622.5 170 1491 330.5l120.8 228c84.8-121.3 170.9-230.4 257.8-323.6 6.7-7.4 10.2-10.9 10.2-10.9l-10.2 10.9c-28.1 31-113.4 130.5-242.1 328.1 123.9-6.2 314.3-31.5 469.6-58.1 46.2-258.8-45.3-377.3-45.3-377.3S1935.5-60.6 1798.9 20.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M1594.4 1320.7l2.7-.5-17.4 1.9-3.1 1.4 17.8-2.8zm-123.3 408.4zm-838 916.1l3.8-10.2a18591.5 18591.5 0 01165.8-421.7 15641.5 15641.5 0 01179.8-422.9 13230.1 13230.1 0 01140.6-306.3c13.9-29.3 27.7-57.9 41.4-86l13.6-27.9 2.2-4.5-14.8 1.6-11.8-23.2-3.5 6.8a9455.5 9455.5 0 00-98.9 202.2A13152.3 13152.3 0 00859 1976.9a16428.8 16428.8 0 00-175.2 420.3 17293.9 17293.9 0 00-103.3 263.3c-22 57.3-43.4 113.8-64.3 169.6l18.6 36.7 16.6-1.8 1.8-5c26.9-73.5 53.5-145.1 79.9-214.8zm800.1-909.5l.2-.1-.2.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BE202E",
    d: "M1393.2 1934.8c-15.4 2.8-31.3 5.5-47.6 8.3l-.3.1a882.5 882.5 0 0047.9-8.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#BE202E",
    d: "M1393.2 1934.8c-15.4 2.8-31.3 5.5-47.6 8.3l-.3.1a882.5 882.5 0 0047.9-8.4z",
    opacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#BE202E",
    d: "M1433.6 1735.5l-.1.1-.2.1 7.6-1.1c10.3-1.5 20.4-3.3 30.2-5.4l-37.5 6.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#BE202E",
    d: "M1433.6 1735.5l-.1.1-.2.1 7.6-1.1c10.3-1.5 20.4-3.3 30.2-5.4l-37.5 6.3z",
    opacity: 0.3
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -9585.3,
    x2: -5326.2,
    y1: 620.5,
    y2: 620.5,
    gradientTransform: "rotate(-65 -2053 -4777.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9e2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#cd2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97826"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M1255.7 1147.6a7375.4 7375.4 0 01111.5-201c39-67.8 78.5-133.6 118.4-197l7-11.3a4636 4636 0 01119.3-179.8l-120.8-228-27.5 33.9c-34.8 43.4-71 90.1-108.1 139.6a6734 6734 0 00-250.6 358.8 7477.4 7477.4 0 00-104.5 164.5l-3.9 6.3 157.2 310.5a9739.8 9739.8 0 01102-196.5z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -9071.2,
    x2: -6533.2,
    y1: 1047.7,
    y2: 1047.7,
    gradientTransform: "rotate(-65 -2053 -4777.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#282662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#662e8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#9f2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#cd2032"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M539.7 2897.1A19572 19572 0 00477 3072l-.9 2.6-8.9 25.2c-14.1 40.1-26.4 76.2-54.5 158.3 46.3 21.1 83.5 76.7 118.7 139.8a253.5 253.5 0 00-82.1-174.2c228.3 10.3 425-47.4 526.7-214.3a421.3 421.3 0 0024.9-47.2c-46.2 58.6-103.5 83.5-211.4 77.4l-.7.3.7-.3c158.8-71.1 238.5-139.3 308.9-252.4 16.7-26.8 32.9-56.1 49.5-88.6-138.9 142.6-299.8 183.2-469.3 152.4l-127.1 13.9-11.8 32.2z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -9346.1,
    x2: -5087,
    y1: 580.8,
    y2: 580.8,
    gradientTransform: "rotate(-65 -2053 -4777.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9e2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#cd2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97826"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M599 2612.4a17175.4 17175.4 0 01260-635.6 12549 12549 0 01228.2-498.5c20.8-42.9 41.8-85.4 63-127.5l3.5-6.8-157.2-310.5-7.7 12.6a6931.4 6931.4 0 00-317.6 576.5 4590.7 4590.7 0 00-93.2 204.1 4121.8 4121.8 0 00-128.1 340.2c-11 35-21.5 70.1-31.4 105a3254.5 3254.5 0 00-60.3 246.2l158 311.9a22072.5 22072.5 0 0182.8-217.6z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -9035.5,
    x2: -6797.2,
    y1: 638.4,
    y2: 638.4,
    gradientTransform: "rotate(-65 -2053 -4777.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#282662"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#662e8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#9f2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#cd2032"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M356.1 2529.2a2425.8 2425.8 0 00-41 298l-.8 10.4c-49.3-79-181.3-156.1-181-155.4 94.5 137 166.2 273 176.9 406.5-50.6 10.4-119.9-4.6-200-34.1 83.5 76.7 146.2 97.9 170.6 103.6-76.7 4.8-156.6 57.5-237.1 118.2 117.7-48 212.8-67 280.9-51.6-108 305.8-216.3 643.4-324.6 1001.8 33.2-9.8 53-32.1 64.1-62.3 19.3-64.9 147.4-490.7 348.1-1050.4l17.3-48 4.9-13.4a20981 20981 0 0165.9-179.7l15.6-41.8.3-.8-157.8-311.8-2.3 10.8z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -9346.1,
    x2: -5087,
    y1: 1021.6,
    y2: 1021.6,
    gradientTransform: "rotate(-65 -2053 -4777.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9e2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#cd2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97826"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M1178.1 1370.3l-13.6 27.9-41.4 86c-15.1 31.7-30.3 64.1-45.7 97.3l-23.4 50.6a13230.1 13230.1 0 00-162.2 367.3A17771.3 17771.3 0 00553.3 2860l-1.8 5 127.1-13.9-7.6-1.3c152-18.9 354-132.5 484.6-272.7 60.2-64.6 114.8-140.8 165.3-230 37.6-66.4 72.9-140 106.5-221.5a3210.9 3210.9 0 0084.8-231.9 460.8 460.8 0 01-119 41.3 759.6 759.6 0 01-47.9 8.4l.3-.1c141.7-54.5 231.1-159.8 296.1-288.7a504.8 504.8 0 01-170.5 74.7 423 423 0 01-30.2 5.4l-7.6 1.1.2-.1.1-.1a576.8 576.8 0 00126.7-70.8 445 445 0 0072.4-68.9 493.6 493.6 0 0050.9-73l13.6-26.8c19.8-39.8 35.6-75.3 48.2-106.5a1005.1 1005.1 0 0034.2-98.9c4.8-17.5 7.7-31.4 9.3-41.5-4.8 3.8-10.3 7.6-16.5 11.3-42.8 25.6-116.2 48.8-175.4 59.7l116.7-12.8-116.7 12.8-2.7.5-17.9 2.9 3.1-1.4-399.3 43.8-2.2 4.3z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -9610.3,
    x2: -5351.2,
    y1: 999.7,
    y2: 999.7,
    gradientTransform: "rotate(-65 -2053 -4777.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9e2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#cd2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97826"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M1627.6 563.1a5389 5389 0 00-116 186.5l-6.6 11.1c-36 60.7-74.3 127.3-114.5 200.3a9859.5 9859.5 0 00-210.1 404.9l399.3-43.8c116.3-53.5 168.3-101.9 218.8-171.9 13.4-19.3 26.9-39.5 40.3-60.4 41-64 81.2-134.5 117.2-204.6a2124.5 2124.5 0 0088.8-195.3c14.9-38.5 26.9-74.3 35.2-105.7 7.3-27.7 13-54 17.4-79.1-155.5 26.5-345.9 51.9-469.8 58z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#BE202E",
    d: "M1369.6 1939.4z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#BE202E",
    d: "M1369.6 1939.4z",
    opacity: 0.3
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -9346.1,
    x2: -5087,
    y1: 1152.7,
    y2: 1152.7,
    gradientTransform: "rotate(-65 -2053 -4777.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9e2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#cd2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97826"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M1369.6 1939.4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#BE202E",
    d: "M1433.2 1735.7l7.6-1.1-7.6 1.1z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#BE202E",
    d: "M1433.2 1735.7l7.6-1.1-7.6 1.1z",
    opacity: 0.3
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -9346.1,
    x2: -5087,
    y1: 1137.7,
    y2: 1137.7,
    gradientTransform: "rotate(-65 -2053 -4777.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9e2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#cd2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97826"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M1433.2 1735.7l7.6-1.1-7.6 1.1z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#BE202E",
    d: "M1433.5 1735.6l.1-.1-.1.1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#BE202E",
    d: "M1433.5 1735.6l.1-.1-.1.1z",
    opacity: 0.3
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -6953.4,
    x2: -6012,
    y1: 1134.7,
    y2: 1134.7,
    gradientTransform: "rotate(-65 -2053 -4777.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#9e2064"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c92037"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#cd2335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97826"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M1433.5 1735.6l.1-.1-.1.1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#6D6E71",
    d: "M2218.7 387v11.7h27.4v77.4h12.7v-77.4h27.6V387h-67.7zm158.3 0l-30.6 62.2-30.8-62.2h-15.3v89.1h11.7v-70.7l30.3 61.3h8.1l30.3-61.3v70.7h11.7V387H2377z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrift);
export default __webpack_public_path__ + "static/media/Thrift.a8c74e3f.svg";
export { ForwardRef as ReactComponent };